import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import OKCancelDialog from '../../atoms/Dialog/OKCancelDialog';
import Typography from '@material-ui/core/Typography';

type StudyButtonProps = {
  studyStatus: number;
  isStudyCheck: boolean;
  //studyFlg: number;
  onClick: () => void;
  onCancelClick: () => void;
};

const DevListStudyButton: React.FC<StudyButtonProps> = (props) => {
  const { t } = useTranslation();
  const [studyStatus, setStudyStatus] = useState<number>(props.studyStatus);
  const [isStudyCheck, setIsStudyCheck] = useState<boolean>(props.isStudyCheck);
  //const [studyFlg, setStudyFlg] = useState<number>(props.studyFlg);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  useEffect(() => {
    setStudyStatus(props.studyStatus);
    setIsStudyCheck(props.isStudyCheck);
  }, [props.studyStatus, props.isStudyCheck]);

  const getStudyButtonColor = (state?: number): string => {
    if (state == undefined) return 'silver';

    switch (state) {
      case 0: //学習未
        return 'gray';
      case 1: //学習中
        return 'royalblue';
      case 2: //学習完了
        return 'green';
      case 3: //学習完了
        return 'green';
      case 4: //学習キャンセル
        return 'gray';
      default:
        //使用不可,不明
        return 'silver';
    }
  };
  const getStudyButtonText = (state?: number): string => {
    if (state == undefined) return t('DevListStudyButton.不明', '不明');

    switch (state) {
      case 0:
        return t('DevListStudyButton.学習前', '学習未');
      case 1:
        return t('DevListStudyButton.学習中', '学習中');
      case 2:
        return t('DevListStudyButton.学習後', '学習完了');
      case 3:
        return t('DevListStudyButton.学習後', '学習完了');
      case 4:
        return t('DevListStudyButton.学習ｷｬﾝｾﾙ', '学習ｷｬﾝｾﾙ');
      case -1:
        return t('DevListStudyButton.使用不可', '使用不可');
      default:
        return t('DevListStudyButton.不明', '不明');
    }
  };

  /**
   *　OK処理
   */
  const handleDialogOkButton = () => {
    if (studyStatus == 1) {
      props.onCancelClick();
    } else {
      props.onClick();
    }
    //setStudyStatus(2);
    setDialogOpen(false);
  };

  /**
   * 確認ダイアログ
   */
  const handleCheckDialogShow = () => {
    if (studyStatus == 1) {
      setShowMessage(t('DevListStudyButton.学習処理をキャンセルします', '学習処理をキャンセルしますか？'));
    } else {
      setShowMessage(t('DevListStudyButton.学習処理を実行します', '学習処理を実行しますか？'));
    }
    setDialogOpen(true);
  };

  //console.debug(['- 画面描画開始 -', props]);
  //学習中の場合はボタン押下でキャンセルとする
  return (
    <div>
      {isStudyCheck || studyStatus == 1 ? (
        <Button
          variant="outlined"
          style={{
            borderColor: getStudyButtonColor(studyStatus),
            color: getStudyButtonColor(studyStatus),
            width: '130px',
          }}
          onClick={() => {
            handleCheckDialogShow();
          }}
        >
          {getStudyButtonText(studyStatus)}
        </Button>
      ) : (
        <div
          style={{
            background: getStudyButtonColor(studyStatus),
            color: 'white',
            padding: '7px',
          }}
        >
          {getStudyButtonText(studyStatus)}
        </div>
      )}
      <OKCancelDialog
        open={dialogOpen}
        onOK={() => handleDialogOkButton()}
        onCancel={() => setDialogOpen(false)}
        title={t('DevListStudyButton.確認', '確認')}
        okText={t('DevListStudyButton.OK', 'OK')}
        cancelText={t('DevListStudyButton.キャンセル', 'キャンセル')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </OKCancelDialog>
    </div>
  );
};

export default DevListStudyButton;
